import { render, staticRenderFns } from "./RecipientListItem.vue?vue&type=template&id=7e5376b7"
import script from "./RecipientListItem.vue?vue&type=script&lang=js"
export * from "./RecipientListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports